module.exports = __webpack_public_path__ + "img/8.f33a1721.png";